import { Deactivatable } from '../deactivatable';

export function canDeactivate(deactivatable: Deactivatable): Promise<boolean> {
  return deactivatable.onDeacivate();
}
